import { reqGetDetailByIds } from "../request/bsplatform/commodity/getDetailByIds/post.js";
const detailMap = new Map();
async function getProductDetail(ids) {
  const newIds = ids.filter((id) => {
    return !detailMap.get(id);
  });
  const newDetail = await reqGetDetailByIds(newIds);
  newDetail.forEach((d) => {
    const { id } = d;
    detailMap.set(id, d);
  });
  return ids.map((id) => detailMap.get(id)).filter((i) => i);
}
export { getProductDetail };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/utils/getUnifySelectDetailByIds.js